import { render, staticRenderFns } from "./RateProvider.vue?vue&type=template&id=76fad903&scoped=true&"
import script from "./RateProvider.vue?vue&type=script&lang=ts&"
export * from "./RateProvider.vue?vue&type=script&lang=ts&"
import style0 from "./RateProvider.vue?vue&type=style&index=0&id=76fad903&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fad903",
  null
  
)

export default component.exports